import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import React from 'react';
const VERTICAL = 'vertical';
const HORIZONTAL = 'horizontal';

const SpacerContainer = styled.div`
display: ${({ spacerType }) =>
  spacerType === VERTICAL ? 'block' : 'inline-block'}
  vertical-align: ${({ spacerType }) =>
    spacerType === HORIZONTAL ? 'middle' : undefined};
`;

const Spacer = ({ children, spacerType = HORIZONTAL, size = 8, ...props }) => {
  const nodes = React.Children.toArray(children)
    .filter((element) => React.isValidElement(element))
    .map((element, index, elements) => {
      return React.cloneElement(element, {
        ...element.props,
        style: {
          ...element.props.style,
          marginRight:
            spacerType === HORIZONTAL && index !== elements.length - 1
              ? size
              : undefined,
          marginBottom:
            spacerType === VERTICAL && index !== elements.length - 1
              ? size
              : undefined,
        },
      });
    });

  return (
    <SpacerContainer spacerType={spacerType} {...props}>
      {nodes}
    </SpacerContainer>
  );
};

Spacer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]),
  spacerType: PropTypes.string,
  size: PropTypes.number,
};

export default Spacer;
